<script lang="ts" setup>
import { onMounted, ref } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { API, ENV } from '../env/externals'
import { usePayrollChange } from '@/app/core/composable/routes/useChangePayroll'
import { DBtn, DLoading, DModal } from 'front-library'
import { usePayrollStore } from '@/store/payroll-data'
import { useUserStore } from '@/store/user'
import { useNotificationsStore } from '@/store/notifications'

const externalIframe = API[ENV()]()

usePayrollChange(() => back())

const router = useRouter()
const route = useRoute()
const notifications = useNotificationsStore()
const iframeUrl = ref('')
const { t } = useI18n()

onMounted(async () => {
  if (route.params?.code) {
    const payrollStore = usePayrollStore()
    const userStore = useUserStore()
    const authorization = await userStore.getValidToken()

    const pathCode = atob(route.params.code.toString())
    const code = pathCode.split('/')?.[1]
    const name = pathCode.split('/')?.[2]

    iframeUrl.value = `${externalIframe}/print-report/${code}/${name}`
    iframeUrl.value += `?token=${authorization}`
    iframeUrl.value += `&companyId=${payrollStore.payroll?.company.id}`
    iframeUrl.value += `&countryId=${payrollStore.payroll?.country.iso_code}`
  }
})
const loading = ref(false)
const messageLoading = ref('')
// modal
const showModal = ref(false)
const titleModal = ref('')
const descriptionModal = ref('')
const typeAlertModal = ref<'success' | 'error' | 'warning'>('success')
const urlFile = ref<string | null>(null)

window.addEventListener(
  'message',
  event => {
    if (event.origin !== iframeUrl.value) return

    let message = JSON.parse(event.data)
    if (message?.type && message?.type !== 'error') return

    if (message?.type && message?.type === 'loading') {
      /*
        {
            type: 'loading',
            status: boolean,
            text?: string
        }
     */
      loading.value = message.status
      messageLoading.value = message.text || 'Generando reporte...'
      return
    }
    if (message?.type && message?.type === 'modal') {
      /*
      {
        type: 'modal',
        title: string,
        text: string,
        alertType: 'success' | 'error' | 'warning',
        urlFile?: string
      }
     */
      titleModal.value = message.title
      descriptionModal.value = message.text
      typeAlertModal.value = message.alertType
      urlFile.value = message.urlFile || null
      showModal.value = true
      return
    }

    notifications.addNotification({
      title: message.title,
      text: message.text,
      type: 'error',
      time: 10000
    })
  },
  false
)

const back = () => {
  router.back()
}
</script>
<template>
  <DLoading v-show="loading" :message="messageLoading" />
  <DModal
    :open="showModal"
    :typeAlert="typeAlertModal"
    :title="titleModal"
    :description="descriptionModal"
    @closeModal="showModal = false">
    <template v-slot:description v-if="urlFile != null">
      <a
        class="underline tracking-widest text-blue-600"
        :href="urlFile"
        target="_blank"
        v-html="t('reports.notification.viewFile')" />
    </template>
  </DModal>
  <div class="h-full px-5 pt-16 pb-5 flex flex-col">
    <iframe :src="iframeUrl" title="Dashboard" class="w-full h-full"></iframe>
    <div class="w-full bg-white p-5">
      <DBtn
        type="button"
        color="secondary"
        @click="back"
        class="px-5 py-2 font-semibold cursor-pointer"
        v-html="t('form.button.back')" />
    </div>
  </div>
</template>
